/**
 * Created by hj on 2017/8/24.
 * change by Jession on 2018/04/04
 * 财务管理 -- 财务对账
 */
import React from 'react';
import {Form, Input, Button, Row, Col, DatePicker, Select, Table, Upload, message, Icon, Modal} from 'antd';
import {hashHistory} from 'react-router';
import {DmsTab, TableView, FilterBox, AdvanceFormNew} from 'Components';
import {openNotice, config, objectSerial} from 'Utils';
import {getVerifyingList, getCheckMonth, confirmFinanceCheck} from '../../service/financialMgm';

class VerifyingList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['财务对账'],
            showHideBtnIndex: 0,
            key: 0,
            // filterBoxVisible: false,
            rows: [
                /*{
                  id: 1,
                  name: 'jsy20171229001',
                  cname: '金胜义',
                  date: '2017-08-24',
                  amount: 1000,
                  remain: 10,
                  type: '对公转账',
                  remark: 'asddddddddddddd'
                },
                {
                  id: 2,
                  name: 'jsy20171229002',
                  cname: '金胜义',
                  date: '2017-12-24',
                  amount: 20,
                  remain: 10,
                  type: '对公转账',
                  remark: '123123123123'
                }*/
            ],
            total: 1,
            searchObj: {
                cusName: '',  // 客户名称
                checkDate: '',  // 账期
                ischeck: 'N',  // 是否确认
                s: 10,
                p: 1
            },
            checkMonthList: [],  //账期
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    advanceReset() {
        /* 重置 */
        this.setState({
            searchObj: {
                // ...this.state.searchObj,
                cusName: '',  // 客户名称
                checkDate: this.state.checkMonthList[this.state.checkMonthList.length - 1].value,  // 账期
                ischeck: 'N',  // 是否确认
                s: 10,
                p: 1
            }
        }, () => {
            this.initData();
            // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
        });
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
    };

    advanceSubmit(form) {  // 查询
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
        this.setState({searchObj: {...this.state.searchObj, p: 1}}, () => {
            this.initData();
            // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
        })
    };

    setFilterParam(name, value) {
        // console.log(value);
        if (name === 'effectDate') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    effectStartDate: value.from,
                    effectEndDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, () => {
            this.initData();
        });
    }

    goView(url) {
        hashHistory.push(url);
    }

    toEdit(index) {
        /* 编辑 */
        this.goView('card/add/' + this.state.rows[index].id);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = {...this.state.searchObj};
        // if (obj.ischeck == '是') {
        //   obj.ischeck = 'Y';
        // } else {
        //   obj.ischeck = 'N';
        // }
        this.setState({
            loading: true
        })
        getVerifyingList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
            }
        })
    }

    /*获取账期*/
    getCheckMonth() {
        getCheckMonth().then(result => {
            if (result.status) {
                // console.log(result);
                this.setState({
                    checkMonthList: result.data.map(x => {
                        return {
                            value: x,
                            text: x
                        }
                    })
                }, () => {
                    this.setState({
                        searchObj: {
                            ...this.state.searchObj,
                            checkDate: this.state.checkMonthList.length ? this.state.checkMonthList[this.state.checkMonthList.length - 1].value : '',  // 账期
                        }
                    }, () => {
                        this.initData();
                    })
                });
            } else {
                message.error(result.message);
            }
        })
    }

    /* 财务确认 */
    confirmFinanceCheck(data) {
        // console.log(data);
        let obj = {
            checkDate: data.checkDate, // 账期（yyyyMM）
            cusId: data.cusId, // 客户id
            startAmount: data.startAmount, // 期初金额
            endAmount: data.endAmount, // 期末金额
            receiveShould: data.receiveShould, // 应收
            riskCountShould: data.riskCountShould, // 应付总额
            riskCountReal: data.riskCountReal, // 已付总额
            recoverAmount: data.recoverAmount // 回款总额
        }
        confirmFinanceCheck(obj).then(res => {
            if (res.status) {
                this.initData();
                openNotice('success', '操作成功', '');
            } else {
                message.error(res.message);
            }
        })
    }

    componentDidMount() {
        // this.initData();
        this.getCheckMonth();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    /* 导出 */
    exportExcel() {
        let params = this.state.searchObj;
        // console.log(rows);
        window.location.href = `${config.server}/api/v1/dms/trans/check/exportCheckAmount?${objectSerial(params)}`;
        /*exportExcel(rows).then(res => {
          if (res.status) {
            this.initData();
            openNotice('success', '操作成功', '');
          } else {
            message.error(res.message);
          }
        })*/
    }

    render() {
        const {opts, key, rows, total, searchObj, showHideBtnIndex, checkMonthList, loading} = this.state;
        // console.log(checkMonthList);
        var self = this;
        const advanceProps = {
            fileds: [
                {
                    name: 'cusName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusName
                },
                {
                    name: 'checkDate',
                    label: '账期',
                    text: '选择账期',
                    options: checkMonthList,
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.checkDate,
                },
                {
                    name: 'ischeck',
                    label: '是否确认',
                    text: '选择是否确认',
                    options: [
                        // { value: '0', text: '全部' },
                        {value: 'Y', text: '是'},
                        {value: 'N', text: '否'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.ischeck || 'N',
                    // defaultValue: 'N'
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'cusId',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '账期',
                    dataIndex: 'checkDate'
                },
                {
                    title: '客户名称',
                    dataIndex: 'cusName'
                },
                {
                    title: '期初金额',
                    dataIndex: 'startAmount'
                },
                {
                    title: '应收-提货',
                    dataIndex: 'receiveShould',
                    render: (text, record, index) => {
                        return record.receiveShould.toFixed(2);
                    }
                },
                {
                    title: '应付',
                    dataIndex: 'riskCountShould'
                },
                {
                    title: '已付',
                    dataIndex: 'riskCountReal'
                },
                {
                    title: '回款',
                    dataIndex: 'recoverAmount'
                },
                {
                    title: '期末金额',
                    dataIndex: 'endAmount',
                    render: (text, record, index) => {
                        return record.endAmount.toFixed(2);
                    }
                },
                {
                    title: '确认状态',
                    dataIndex: 'ischeck',
                    render: (text, record, index) => {
                        return text == 'Y' ? '是' : '否';
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    render: (text, record, index) => {
                        if (record.ischeck == 'Y') {
                            return null;
                        } else {
                            return (
                                <Button onClick={this.confirmFinanceCheck.bind(this, record)}>确认</Button>
                            )
                        }
                    }
                }
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.exportExcel.bind(this)} style={{position: 'absolute', bottom: 8, right: 0}}
                            icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}
;
export default VerifyingList;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/verifyingList.js